import React, { useState } from "react";
import { Page, BlockStack } from "@shopify/polaris";
import { useAppSelector } from "../../redux/hooks";
import { getIsAdmin } from "../../redux/slices/env";
import { Navigate } from "react-router-dom";
import { paths } from "@/shared/refs/paths";
import Shops from "./componets/Shops";
import { httpsSaveShopAsTemplate, httpsMigrateSubscriptions } from "../../firebase/https";

export default function Admin() {
  const isAdmin = useAppSelector(getIsAdmin);
  const [templateLoading, setTemplateLoading] = useState(false);
  const [migrateLoading, setMigrateLoading] = useState(false);

  if (!isAdmin) return <Navigate to={paths.home()} replace />;

  const handleCopyTemplates = async () => {
    setTemplateLoading(true);
    try {
      const res = await httpsSaveShopAsTemplate();
      if (res.success) {
        if ((window as any).shopify) {
          (window as any).shopify.toast.show(res.message);
        } else {
          alert(res.message);
        }
      } else {
        if ((window as any).shopify) {
          (window as any).shopify.toast.show("Template copy failed.", { isError: true });
        } else {
          alert("Template copy failed.");
        }
      }
    } catch (e: any) {
      console.error(e);
      const errMsg = e.message || "An error occurred.";
      if ((window as any).shopify) {
        (window as any).shopify.toast.show(errMsg, { isError: true });
      } else {
        alert(errMsg);
      }
    } finally {
      setTemplateLoading(false);
    }
  };

  const handleMigrateSubscriptions = async () => {
    setMigrateLoading(true);
    try {
      const res = await httpsMigrateSubscriptions();
      if (res.success) {
        if ((window as any).shopify) {
          (window as any).shopify.toast.show(res.message);
        } else {
          alert(res.message);
        }
      } else {
        if ((window as any).shopify) {
          (window as any).shopify.toast.show("Subscription migration failed.", { isError: true });
        } else {
          alert("Subscription migration failed.");
        }
      }
    } catch (e: any) {
      console.error(e);
      const errMsg = e.message || "An error occurred.";
      if ((window as any).shopify) {
        (window as any).shopify.toast.show(errMsg, { isError: true });
      } else {
        alert(errMsg);
      }
    } finally {
      setMigrateLoading(false);
    }
  };

  return (
    <Page 
      title="Admin" 
      fullWidth
      secondaryActions={[
        {
          content: "Copy templates",
          onAction: handleCopyTemplates,
          loading: templateLoading,
        },
        {
          content: "Migrate Subscriptions",
          onAction: handleMigrateSubscriptions,
          loading: migrateLoading,
        }
      ]}
    >
      <BlockStack gap="500">
        <Shops />
      </BlockStack>
    </Page>
  );
}
